import React from 'react';
import { GridItem } from '@chakra-ui/react';
import { Body, Heading, Icon, SimpleGrid, Link } from '@hover/blueprint';
import { iPlayCircle } from '@hover/icons';
import { PARTNER_BEACON_RESOURCES_PAGE_VIDEOS } from '../../../constants';

const VideoGrid = () => (
  <SimpleGrid minChildWidth={360} gap={10} w="100%" justifyItems="center">
    {PARTNER_BEACON_RESOURCES_PAGE_VIDEOS.map(v => (
      <GridItem
        maxW={{ base: '100%', tablet: 360 }}
        d="flex"
        flexDir="column"
        gap={5}
        alignItems="flex-start"
        height="100%"
        key={v.heading}
      >
        <Link href={v.href} mb={4}>
          {v.cover}
        </Link>
        <Heading size={{ tablet: 600, base: 500 }} style={{ marginBottom: 0 }}>
          {v.heading}
        </Heading>
        <Body size={500}>{v.body}</Body>
        <Link
          href={v.href}
          color="primary.600"
          d="flex"
          gap={2}
          alignItems="center"
        >
          <Icon icon={iPlayCircle} />
          Watch
        </Link>
      </GridItem>
    ))}
  </SimpleGrid>
);

export default VideoGrid;
